export const AgentCarBookingData = [
  {
    key: "1",
    id: "#CB-1245",
    carName: "Volkswagen Amarok",
    carType: "Sedan",
    bookedBy: "Lynwood Dickens",
    bookedLocation: "Texas",
    travellers: "2 Adults, 1 Child",
    days: "4 Days",
    pricing: "$1,569",
    bookedOn: "15 May 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "2",
    id: "#CB-3215",
    carName: "Toyota Camry SE 400",
    carType: "Hatchback",
    bookedBy: "James Osborne",
    bookedLocation: "California",
    travellers: "2 Adults, 2 Child",
    days: "3 Days",
    pricing: "$1,745",
    bookedOn: "20 May 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "3",
    id: "#CB-4581",
    carName: "Ford Mustang 4.0 AT",
    carType: "Coupe",
    bookedBy: "Steve Grieve",
    bookedLocation: "Newyork",
    travellers: "2 Adults, 1 Child",
    days: "2 Days",
    pricing: "$2,160",
    bookedOn: "04 Jun 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "4",
    id: "#CB-6545",
    carName: "Ferrari 458 MM Special",
    carType: "SUV",
    bookedBy: "Alene Downing",
    bookedLocation: "Florida",
    travellers: "1 Adult, 1 Child",
    days: "2 Days",
    pricing: "$1,840",
    bookedOn: "17 Jun 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "5",
    id: "#CB-3256",
    carName: " Mercedes-benz ",
    carType: "Sports",
    bookedBy: "Carol Gardner",
    bookedLocation: "Georgia",
    travellers: "2 Adults, 2 Child",
    days: "3 Days,",
    pricing: "$1,450",
    bookedOn: "25 Jun 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "6",
    id: "#CB-3654",
    carName: "BMW 3.0 Gran Turismo",
    carType: "Hatchback",
    bookedBy: "Enrique Archer",
    bookedLocation: "Las Vegas",
    travellers: "3 Adults, 2 Child",
    days: "4 Days",
    pricing: "$1,600",
    bookedOn: "02 Jul 2025",
    status: "Cancelled",
    action: "cancelled",
  },
  {
    key: "7",
    id: "#CB-1458",
    carName: "Infiniti QX60 ",
    carType: "Hatchback",
    bookedBy: "Weston Carrasco",
    bookedLocation: "Texas",
    travellers: "2 Adults, 2 Child",
    days: "2 Days",
    pricing: "$2,380",
    bookedOn: "12 Jul 2025",
    status: "Completed",
    action: "completed",
  },
  
  {
    key: "8",
    id: "#CB-6589",
    carName: "Toyota 86 Coupe",
    carType: "Sedan",
    bookedBy: "Bonnie Coleman",
    bookedLocation: "California",
    travellers: "1 Adult, 1 Child",
    days: "3 Days",
    pricing: "$1,400",
    bookedOn: "26 Jul 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "9",
    id: "#CB-2315",
    carName: "Jeep Wrangler",
    carType: "Coupe",
    bookedBy: "Aurora Conklin",
    bookedLocation: "Georgia",
    travellers: "2 Adults, 1 Child",
    days: "2 Days",
    pricing: "$1,810",
    bookedOn: "10 Aug 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "10",
    id: "#CB-5414",
    carName: "Jaguar XK",
    carType: "Sports",
    bookedBy: "Robin Banks",
    bookedLocation: "Las Vegas",
    travellers: "3 Adults, 1 Child",
    days: "2 Days",
    pricing: "$1,450",
    bookedOn: "22 Aug 2025",
    status: "Completed",
    action: "completed",
  },
  
];
